export default "__VITE_ASSET__0c364bfc__"